<template lang="pug">
    d2-container( )
            el-form(:inline='true', :model='dataForm',label-position='right' label-width='89px' size='mini')
              el-row(:span='24')
                el-col(:md='7' :sm="24")
                  el-form-item(label="主办方名称:")
                      el-input.inputWidth(v-model='dataForm.name', placeholder='主办方名称', clearable='')
                el-col(:md='13' :sm="24")
                  el-form-item(label="地区:" label-width='72px' )
                      el-select.inputWidth(v-model="dataForm.proviceId" placeholder="请选择"  @change="changeProvice"  clearable)
                        el-option(v-for="(item,index) in proviceList" :key="index" :label="item.name" :value="item.proviceId")
                      font &nbsp;&nbsp;省&nbsp;&nbsp;
                      el-select.inputWidth(v-model="dataForm.cityId" placeholder="请选择"  clearable)
                        el-option(v-for="(item,index) in cityList" :key="index" :label="item.cityname" :value="item.cityId")
                      font  &nbsp;&nbsp;市&nbsp;
              el-row(style="padding-bottom:15px;" ,:span="24")
                el-col(:span='23')
                  el-button(v-if="isAuth('sys:org:save')", type='primary', @click='addOrUpdateHandle()') 新增
                  el-button(v-if="isAuth('sys:org:delete')", type='danger', @click='deleteHandle()', :disabled='dataListSelections.length <= 0') 删除
                el-col(:span='1' style='float:right')
                  el-button(@click='getDataList()',icon='el-icon-search',type='primary' style='float:right;' ) 查询
            el-table(:data='dataList', border='', v-loading='dataListLoading', @selection-change='selectionChangeHandle', style='width: 100%;')
                el-table-column(type="selection" width="55")
                el-table-column(prop='name', header-align='center', align='center', label='主办方名称')
                el-table-column(prop='proviceName', header-align='center', align='center', label='省')
                el-table-column(prop='cityName', header-align='center', align='center', label='市')
                el-table-column(prop='byx1', header-align='center', align='center', label='比赛类型')
                el-table-column(prop='accountName', header-align='center', align='center', label='开户名')
                  template(slot-scope='scope')
                    span(:title="scope.row.accountName") {{scope.row.accountName || ''}}
                el-table-column(prop='accountBank', header-align='center', align='center', label='开户行')
                  template(slot-scope='scope')
                    span(:title="scope.row.accountBank") {{scope.row.accountBank || ''}}
                el-table-column(prop='accountNo', header-align='center', align='center', label='账号')
                  template(slot-scope='scope')
                    span(:title="scope.row.accountNo") {{scope.row.accountNo || ''}}
                el-table-column(prop='taxId', header-align='center', align='center', label='税号')
                  template(slot-scope='scope')
                    span(:title="scope.row.taxId") {{scope.row.taxId || ''}}
                el-table-column(prop='accountAddress', header-align='center', align='center', label='地址')
                  template(slot-scope='scope')
                    span(:title="scope.row.accountAddress") {{scope.row.accountAddress || ''}}
                el-table-column(prop='contactName', header-align='center', align='center', label='联系人')
                  template(slot-scope='scope')
                    span(:title="scope.row.contactName") {{scope.row.contactName || ''}}
                el-table-column(prop='contactPhone', header-align='center', align='center', label='联系电话')
                  template(slot-scope='scope')
                    span(:title="scope.row.contactPhone") {{scope.row.contactPhone || ''}}
                el-table-column(prop='remark', header-align='center', align='center', label='主办方简介')
                  template(slot-scope='scope')
                    span(:title="scope.row.remark") {{scope.row.remark | ellipsis}}
                el-table-column(prop='remark', header-align='center', align='center', label='启用/停用')
                  template(slot-scope='scope')
                    el-switch(v-model="scope.row.status === 1" @change="changeHideStatus(scope.row.id, scope.row.status)")
                el-table-column(prop='',header-align='center',align='center',label='操作',width='100')
                    template(slot-scope="scope")
                      el-menu.menuPonit(:collapse="isCollapse")
                        el-submenu(index="1")
                            template(slot="title")
                                i(class="el-icon-more" style='color:#02B90D;')
                            el-menu-item-group()
                                el-menu-item(index="1-1" v-if="isAuth('sys:org:update')"  @click="addOrUpdateHandle(scope.row.id)") 修改
                                el-menu-item(index="1-2" v-if="isAuth('sys:org:delete') && scope.row.byx2!=1"  @click="deleteHandle(scope.row.id)") 删除
            el-pagination(@size-change='sizeChangeHandle', @current-change='currentChangeHandle', :current-page='pageIndex', :page-sizes='[10, 20, 50, 100]', :page-size='pageSize', :total='totalPage', layout='total, sizes, prev, pager, next, jumper')
            add-or-update(v-if='addOrUpdateVisible', ref='addOrUpdate', @refreshdatalist='getDataList')
</template>
<script>
import AddOrUpdate from './org-add-or-update'
export default {
  name: 'org',
  filters: {
    ellipsis (value) {
      if (!value) return ''
      if (value.length > 20) {
        return value.slice(0, 20) + '...'
      }
      return value
    }
  },
  data () {
    return {
      isCollapse: true,
      dataForm: {
        name: '',
        proviceId: '',
        cityId: ''
      },
      ctTypeList: [
        { key: '1', label: '常规赛' },
        { key: '2', label: '月度赛' },
        { key: '3', label: '季度赛' },
        { key: '4', label: '年度总决赛' }
      ],
      proviceList: [],
      cityList: [],
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      dataListSelections: [],
      addOrUpdateVisible: false
    }
  },
  components: {
    AddOrUpdate
  },
  created () {
    this.getDataList()
    this.initProvice()
  },
  methods: {
    // 获取数据列表
    getDataList () {
      this.dataListLoading = true
      this.$http({
        url: this.$http.adornUrl('/sysOrg/orgList'),
        method: 'get',
        params: this.$http.adornParams({
          'page': this.pageIndex,
          'limit': this.pageSize,
          'name': this.dataForm.name,
          'proviceId': this.dataForm.proviceId,
          'cityId': this.dataForm.cityId
        })
      }).then((data) => {
        if (data && data.code === 0) {
          this.dataList = data.page.records
          this.dataList.forEach(a => {
            let ctType = []
            a.byx1.split(',').forEach(e => {
              this.ctTypeList.forEach(c => {
                if (e === c.key) {
                  ctType.push(c.label)
                }
              })
            })
            a.byx1 = ctType.join(',')
          })

          this.totalPage = data.page.total
        } else {
          this.dataList = []
          this.totalPage = 0
        }
        this.dataListLoading = false
      })
    },
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle (val) {
      this.pageIndex = val
      this.getDataList()
    },
    // 多选
    selectionChangeHandle (val) {
      this.dataListSelections = val
    },
    // 新增 / 修改
    addOrUpdateHandle (id) {
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id)
      })
    },
    initProvice () {
        this.$http({
        url: this.$http.adornUrl('/dicProvince/list'),
        method: 'get',
        params: this.$http.adornParams()
      }).then((data) => {
        this.proviceList = data && data.code === 0 ? data.list : []
      })
    },
    changeProvice () {
      this.cityList = []
      this.dataForm.cityId = ''
        this.$http({
            url: this.$http.adornUrl('/dicProvinceCity/list'),
            method: 'get',
            params: this.$http.adornParams({
                'proviceId': this.dataForm.proviceId
        })
          }).then((data) => {
            this.cityList = data && data.code === 0 ? data.list : []
          })
    },
    // 删除
    deleteHandle (id) {
      var ids = id ? [id] : this.dataListSelections.map(item => {
        return item.id
      })

      this.$confirm(`是否删除主办方?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false
      }).then(() => {
        this.$http({
          url: this.$http.adornUrl('/sysOrg/delete'),
          method: 'post',
          data: this.$http.adornData(ids, false)
        }).then((data) => {
          if (data && data.code === 0) {
            this.$message({
              message: '操作成功',
              type: 'success',
              duration: 1500,
              onClose: () => {
                this.getDataList()
              }
            })
          } else {
            this.$message.error(data.msg)
          }
        })
      }).catch(() => {})
    },
    changeHideStatus (id, status) {
      this.$confirm(
        `
          ${status === 1
          ? '确认将该主办方停用吗？'
          : '将展示全部场地，如需调整请前往运营管理页面手动关闭展示'}
        `,
      '提示',
      {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          this.$http({
            url: this.$http.adornUrl('/sysOrg/updateStatus'),
            method: 'post',
            data: {
              id,
              status: status === 0 ? 1 : 0
            }
          }).then(data => {
            if (data && data.code === 0) {
              this.$message({
                message: `该主办方已${status === 1 ? '停用' : '启用'}`,
                type: `${status === 1 ? 'warning' : 'success'}`
              })
              this.getDataList()
            } else {
              this.$message.error(data.msg)
            }
          })
        })
        .catch(() => {
        })
    }
  }
}
</script>
<style >
  /* 操作三点 菜单样式 */
 @import '../../css/opr3dot.css';

 .inputWidth{
   width: 210px;
 }
</style>
